import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { tap } from 'rxjs';
import { QuickQuoteCIHelper } from 'src/app/components/apg-quick-quote/apg-quick-quote-critical-illness/quick-quote-ci.helper';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { AnswerModel, QuoteModel } from 'src/app/models/quote.model';
import { ApiService } from 'src/app/services/api.service';
import { QuestionService } from 'src/app/services/question.service';
import { SiteContentService } from 'src/app/services/site-content.service';
import { Loader } from 'src/app/util/loader';
import { CustomQuoteComponent } from './custom-quote/custom-quote.component';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';

@Component({
  selector: 'app-apg-quick-quote-critical-illness',
  templateUrl: './apg-quick-quote-critical-illness.component.html',
  styleUrls: ['./apg-quick-quote-critical-illness.component.scss'],
})
export class ApgQuickQuoteCriticalIllnessComponent implements OnInit, OnChanges {

  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() quote: QuoteModel;
  @Output() continue = new EventEmitter<QuoteModel>();
  @Output() back = new EventEmitter<QuoteModel>();
  @ViewChild(CustomQuoteComponent) customQuote: CustomQuoteComponent;

  includeCIQuestion: QQQuestionViewModel;
  answersObject: any;
  loading: boolean;
  quoteCI1: QuoteModel;
  quoteCI2: QuoteModel;
  error: string;

  ciTerm: number;
  includeCI: boolean = null;

  constructor(
    private api: ApiService,
    private siteContentService: SiteContentService,
    private ciHelper: QuickQuoteCIHelper,
    private loader: Loader,
    questionService: QuestionService) {

    this.includeCIQuestion = questionService.createQuestion(
      'IncludeCI',
      'Select',
      'Would you like to include additional Life with up to 200% Multi-Claim Critical Illness cover?',
      {
        options: [{ Value: 'Y', Label: 'Yes' }, { Value: 'N', Label: 'No' }],
        helpKey: 'QuickQuote.CriticalIllnessHelp'
      }
    );

    this.includeCIQuestion.onChange.pipe(
      tap(x => this.includeCIChanged(x === 'Y'))
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quote']?.currentValue) {
      this.ciTerm = this.ciHelper.getCITerm(this.quote);
    }
  }

  ngOnInit() {
  }

  async select(quote: QuoteModel) {
    this.loader.loading = true;
    try {
      const rsp = await this.api.sendQuote(quote.key);
      this.continue.emit(quote);
    } catch (e) {
      console.log(e);
      let content = await this.siteContentService.getSiteContent("QuickQuote.ApiAccessError");
      this.error = content.body;
    } finally {
      this.loader.loading = false;
    }
  }

  includeCIChanged(value: boolean) {
    this.includeCI = value;
    if (this.includeCI) {
      this.getOptions();
    }
  }

  async getOptions() {
    this.loading = true;
    this.quoteCI1 = null;
    this.quoteCI2 = null;

    try {
      var sa = this.quote.answers.find(x => x.key === 'ProtectionLevel_1')?.value;

      var CI1SA = await this.getSumAssured(sa, 1);
      var CI2SA = await this.getSumAssured(sa, 2);

      const rspCI1 = await this.ciHelper.getCIQuote(this.quote, CI1SA, this.ciTerm);
      if (rspCI1.error) {
        this.error = rspCI1.error;
        return;
      }

      const rspCI2 = await this.ciHelper.getCIQuote(this.quote, CI2SA, this.ciTerm);
      if (rspCI2.error) {
        this.error = rspCI2.error;
        return;
      }
      this.quoteCI1 = rspCI1.quote;
      this.quoteCI2 = rspCI2.quote;

    } catch (err) {
      let content = await this.siteContentService.getSiteContent("QuickQuote.ApiAccessError");
      this.error = content.body;
    } finally {
      this.loading = false;
    }
  }

  changeQuote(quote: QuoteModel) {
    this.quickQuote.saveAnswer('CoverSource', null)
    this.back.emit(quote);
  }  

  async getSumAssured(input: string, multiplier: number) {
    const sumAssurred = parseFloat(input);

    return this.ciHelper.calculateSumAssured(sumAssurred, multiplier);
  }

}
